const REQUEST_BODY_TYPES = {
    formData: {
        name: 'Form-Data',
        id: 'form-data',
    },
    rawJson: {
        name: 'JSON',
        id: 'raw json',
    },
}

export {
    REQUEST_BODY_TYPES,
}
